<template>
  <div class="xl:mb-twentyFive">
    <div class="xl:flex mt-twentyFive">
      <div class="xl:border-border xl:border xl:border-solid xl:pr-twentyFive xl:border-t-0 xl:border-b-0 xl:border-l-0 flex w-full xl:w-fit xl:mr-twentyFive justify-between items-center mb-base xl:mb-none whitespace-nowrap">
        <div class="min-w-hundredTen">
          <TextSkeleton
            v-if="envelopeTotal === undefined || loading"
            :characters="25"
            :pulse="true"
          />
          <span v-else>{{ $tc('ui.envelopes.envelopesPage.header.envelopeFilterResultTotal', envelopeTotal, { x: envelopeTotal }) }}</span>
        </div>
        <hr class="flex-grow mx-base xl:hidden" />
        <RouterLink to="/envelope/create">
          <IconButton
            class="xl:hidden"
            icon="plus">
            <span>{{ $t('envelope.newEnvelope') }}</span>
          </IconButton>
        </RouterLink>
      </div>
      <div class="flex overflow-x-scroll xl:overflow-x-auto pb-base xl:pb-0 xl:flex-wrap gap-base">
        <EnvelopeStatusPill
          v-for="(status, index) in envelopeStatusList"
          @click.native="handleStatusSelection(status)"
          :key="index"
          :size="pillSize"
          :hoverable="true"
          :variant="status.variant"
          :text="`${status.label} (${aggregates[status.name] || 0})`"
          :selected="status.selected"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TextSkeleton from '@/components/library/skeletons/TextSkeleton.vue';
import IconButton from '@/components/library/buttons/IconButton.vue';
import EnvelopeStatusPill from '@/components/ui/envelopes/EnvelopeStatusPill.vue';

export default {
  name: 'EnvelopesPageHeader',
  components: {
    IconButton,
    EnvelopeStatusPill,
    TextSkeleton,
  },
  props: {
    loading: {
      type: Boolean,
    },
    envelopeTotal: {
      type: Number,
    },
    aggregates: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      envelopeStatusList: [
        {
          label: this.$t('envelope.status.inProgress'),
          variant: 'inProgress',
          selected: false,
          name: 'sent',
        },
        {
          label: this.$t('envelope.status.draft'),
          variant: 'draft',
          selected: false,
          name: 'draft',
        },
        {
          label: this.$t('envelope.status.signed'),
          variant: 'signed',
          selected: false,
          name: 'signed',
        },
        {
          label: this.$t('envelope.status.rejected'),
          variant: 'rejected',
          selected: false,
          name: 'rejected',
        },
        {
          label: this.$t('envelope.status.unverified'),
          variant: 'unverified',
          selected: false,
          name: 'verify',
        },
        {
          label: this.$t('envelope.status.expired'),
          variant: 'expired',
          selected: false,
          name: 'expired',
        },
        {
          label: this.$t('envelope.status.cancelled'),
          variant: 'cancelled',
          selected: false,
          name: 'cancelled',
        },
      ],
    };
  },
  computed: {
    pillSize() {
      return window.innerWidth <= 768 ? 'large' : 'normal';
    },
    currentStatusFilters() {
      return this.envelopeStatusList.filter(status => status.selected).map(status => status.name);
    },
  },
  methods: {
    emitFilters() {
      this.$emit('statusesUpdated', this.currentStatusFilters);
    },
    handleStatusSelection(status) {
      const statusToToggle = this.envelopeStatusList.find(item => item.name === status.name);
      statusToToggle.selected = !statusToToggle.selected;
      this.emitFilters();
    },
  },
};
</script>
